// Politique d'accès par rôle (miroir de la policy backend)
// Doit rester aligné avec /app/backend/server.py rbac_middleware

// Pages réservées aux admin (chemins frontend complets ou préfixes)
export const ADMIN_ONLY_PATHS = [
  "/produits",            // CRUD produits
  "/distributeurs",       // CRUD distributeurs (les opérateurs voient les ventes via /ventes)
  "/revendeurs",          // CRUD revendeurs B2B (admin only)
  "/contacts",            // Carnet d'adresses agrégé (admin only)
  "/partenaires",         // Partenaires d'intervention 1er niveau + retraits machine (admin only)
  "/packs",               // Packs B2B prêts-à-vendre (admin only)
  "/ordres",              // Ordres de fabrication
  "/commandes-clients",   // Commandes clients
  "/bons-livraison",      // Bons de livraison
  "/factures",            // Factures
  "/devis",               // Devis traiteur événementiel (admin only)
  "/carte-traiteur",      // Catalogue traiteur (admin only — Phase 101er)
  "/courriers",           // Courriers corporate (admin only — Phase 87av)
  "/inventaires",         // Inventaires
  "/reconciliation",      // Réconciliation opérationnelle (admin only)
  "/parties",             // Carnet central (vague 1 refonte relationnelle)
  "/parametres",          // Paramètres + gestion utilisateurs
];

// Pages autorisées au profil field_operator (tournée distributeurs)
// Tout le reste est refusé. Liste exhaustive.
export const FIELD_OPERATOR_PATHS = [
  "/",                          // dashboard custom tournée
  "/tournee",                   // dashboard tournée principal
  "/tableau-de-bord",           // fallback (mais redirigera vers /tournee)
  "/tableau-de-bord-tournee",   // Phase 101gc — ancien FieldOperatorDashboard
  "/distributeurs",             // liste filtrée automatique (filtre backend)
  "/tournees-reappro",          // Phase 88 — tournées de réappro (préparation + impression)
  "/restock",                   // mode tablette terrain
  "/scan",                      // scanner code-barres
  "/stocks",                    // états de stock par lot
  "/guide",                     // pense-bête opérateur (lecture seule)
  "/retrait-mobile",            // Phase 101dc — retrait rapide mobile
];

// Phase 101gc — Rôle `driver` : verrouillé au module Tournée terrain UNIQUEMENT.
// Whitelist ultra-stricte, aligné avec le RBAC backend.
export const DRIVER_PATHS = [
  "/tournee",
  "/tournees-reappro",   // Phase 101gf — accès aux pages terrain (lecture + clôture via /terrain)
  "/login",
];

export function canAccessPath(role, path) {
  if (role === "admin") return true;
  if (!role) return false;

  // driver : whitelist ultra-stricte (Phase 101gc)
  if (role === "driver") {
    return DRIVER_PATHS.some((p) => path === p || path.startsWith(p + "/"));
  }

  // field_operator : whitelist stricte
  if (role === "field_operator") {
    return FIELD_OPERATOR_PATHS.some((p) => path === p || path.startsWith(p + "/"));
  }

  // operator (par défaut)
  return !ADMIN_ONLY_PATHS.some((p) => path === p || path.startsWith(p + "/"));
}

export function isAdmin(user) {
  return user && user !== false && user.role === "admin";
}

export function isFieldOperator(user) {
  return user && user !== false && user.role === "field_operator";
}

export function isDriver(user) {
  return user && user !== false && user.role === "driver";
}

export function roleLabel(role) {
  if (role === "admin") return "Administrateur";
  if (role === "driver") return "Livreur (tournée uniquement)";
  if (role === "field_operator") return "Tournée distributeurs";
  if (role === "operator") return "Opérateur";
  return role;
}
